/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface StatsMitmItem
 */
export interface StatsMitmItem {
    /**
     * 
     * @type {string}
     * @memberof StatsMitmItem
     */
    mitm_domain?: string;
    /**
     * 
     * @type {number}
     * @memberof StatsMitmItem
     */
    view_count?: number;
    /**
     * 
     * @type {number}
     * @memberof StatsMitmItem
     */
    unique_ip_count?: number;
    /**
     * 
     * @type {string}
     * @memberof StatsMitmItem
     */
    token_tag?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof StatsMitmItem
     */
    allowed_domains?: Array<string>;
}

/**
 * Check if a given object implements the StatsMitmItem interface.
 */
export function instanceOfStatsMitmItem(value: object): value is StatsMitmItem {
    return true;
}

export function StatsMitmItemFromJSON(json: any): StatsMitmItem {
    return StatsMitmItemFromJSONTyped(json, false);
}

export function StatsMitmItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): StatsMitmItem {
    if (json == null) {
        return json;
    }
    return {
        
        'mitm_domain': json['mitm_domain'] == null ? undefined : json['mitm_domain'],
        'view_count': json['view_count'] == null ? undefined : json['view_count'],
        'unique_ip_count': json['unique_ip_count'] == null ? undefined : json['unique_ip_count'],
        'token_tag': json['token_tag'] == null ? undefined : json['token_tag'],
        'allowed_domains': json['allowed_domains'] == null ? undefined : json['allowed_domains'],
    };
}

export function StatsMitmItemToJSON(json: any): StatsMitmItem {
    return StatsMitmItemToJSONTyped(json, false);
}

export function StatsMitmItemToJSONTyped(value?: StatsMitmItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'mitm_domain': value['mitm_domain'],
        'view_count': value['view_count'],
        'unique_ip_count': value['unique_ip_count'],
        'token_tag': value['token_tag'],
        'allowed_domains': value['allowed_domains'],
    };
}

